module.exports = __webpack_public_path__ + "media/public/img/expedia-review-icon-01-a87bc78b7598d85b990f437e1e020229.svg";